import { Skeleton } from "@/app/components/shadcn/skeleton";

const SizeRecommendationSkeleton = () => {
  return (
    <div className="border rounded-lg p-4 flex items-center gap-3 bg-gray-50">
      <Skeleton className="w-8 h-8 rounded-full shrink-0" />
      <Skeleton className="h-4 flex-1" />
    </div>
  );
};

export default SizeRecommendationSkeleton;